import axios from 'axios';

const API_URL = `${import.meta.env.VITE_BACKEND_URL}/api/onboarding`;

export const onboardingApi = {
  initialize: async () => {
    const response = await axios.post(`${API_URL}/initialize`);
    return response.data;
  },

  saveCompanyInfo: async (data) => {
    const response = await axios.post(`${API_URL}/company`, data);
    return response.data;
  },

  saveMarkets: async (data) => {
    const response = await axios.post(`${API_URL}/markets`, data);
    return response.data;
  },

  saveProduct: async (data) => {
    const response = await axios.post(`${API_URL}/product`, data);
    return response.data;
  },

  getForecast: async (data) => {
    const response = await axios.post(`${API_URL}/forecast`, data);
    return response.data;
  },

  saveForecast: async (data) => {
    const response = await axios.post(`${API_URL}/saveforecast`, data);
    return response.data;
  },

  saveChannels: async (data) => {
    const response = await axios.post(`${API_URL}/channels`, data);
    return response.data;
  },

  saveDocuments: async (documents) => {
    const formData = new FormData();
  
    Object.entries(documents).forEach(([docType, file]) => {
      if (file && file instanceof File) {
        formData.append(docType, file);
      }
    });
  
    try {
      const response = await axios.post(`${API_URL}/documents`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
  
      console.log('Response data:', response.data); // Log response data to debug
  
      // Transform the response object into an array
      const documentsArray = Object.values(response.data).map((doc) => ({
        document_type: doc.document_type,
        file_name: doc.file_name,
        file_url: doc.file_url,
        status: doc.status,
        uploaded_at: doc.uploaded_at,
      }));
  
      return documentsArray;
    } catch (error) {
      console.error('Error uploading documents:', error);
      throw error;
    }
  },
  
  
  

  getCurrentStep: async () => {
    const response = await axios.get(`${API_URL}/current-step`);
    return response.data;
  },

  getStatus: async () => {
    const response = await axios.get(`${API_URL}/status`);
    return response.data;
  },

  getOnboardingData: async () => {
    const response = await axios.get(`${API_URL}/data`);
    return response.data;
  }
}; 